export const SPECIALTIESS = "/ph/ms1/api/specialite/all"
export const SPECIALTIE = "/ph/ms1/api/specialite/all?id=:param"
export const SPECIALTIES_CREATE = "/api/ADD_Specialtie"
export const SPECIALTIES_ACTIVATE = "/api/Specialtie/:param/activate"
export const SPECIALTIES_DEACTIVATE = "/api/Specialtie/:param/deactivate"
export const SPECIALTIES_DELETE = "/api/Specialtie/:param/delete"

export const EXPORT_SPECIALTIES = "/api/Specialtie/export"
export const IMPORT_SPECIALTIES = "/api/Specialtie/import"
